export default __webpack_public_path__ + "static/media/play-video.922ffb4f.svg";